import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { isTouchDevice } from '../utilities/feature-tests';

const withOutsideClickListener = ComposedComponent => class extends Component {
  constructor() {
    super();

    this.state = {
      isActive: false,
    };

    this.onToggleActive = this.onToggleActive.bind(this);
    this.onSetActiveTrue = this.onSetActiveTrue.bind(this);
    this.onSetActiveFalse = this.onSetActiveFalse.bind(this);
  }

  componentDidMount() {
    this.listener = (e) => this.handleDocumentClick(e);
    window.addEventListener(isTouchDevice() ?
      'touchend' : 'click', this.listener);
  }

  componentWillUnmount() {
    window.removeEventListener(isTouchDevice() ?
      'touchend' : 'click', this.listener);

    this.windowClickListener = null;
  }

  render() {
    return (
      <ComposedComponent
        { ...this.props }
        toggleActive={ this.onToggleActive }
        setActiveTrue={ this.onSetActiveTrue }
        setActiveFalse={ this.onSetActiveFalse }
        isActive={ this.state.isActive }/>
    );
  }

  onToggleActive() {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  onSetActiveTrue() {
    this.setState({
      isActive: true,
    });
  }

  onSetActiveFalse() {
    this.setState({
      isActive: false,
    });
  }

  handleDocumentClick(e) {
    const { isActive } = this.state;

    const isOutsideClick = !ReactDOM.findDOMNode(this).contains(e.target);

    if (isActive && isOutsideClick) {
      this.setState({
        isActive: false,
      });
    }
  }
};

export default withOutsideClickListener;
